import * as React from 'react';
import {useState} from 'react';

import Progress from '../ProgessBar/ProgessBar';
import ButtonArrow from '../FerrariIcon/ButtonArrow';

import cl from 'classnames';

import s from './WelcomePage.module.css';

export default function WelcomePage(props) {
  const {
    testsCompleted,
    testsTotal,
    sections,
    order,
    percent,
    changePage,
    animationState,
    current,
    intro,
    user,
  } = props;
  return (
    <div>
      <div className={cl(s.Description, animationState === 'exiting' ? s.Exiting : '')}>
        <div className={s.Welcome}> Welcome {user}! </div>
        <div className={s.WelcomeText}>{intro}</div>
      </div>
      <div className={cl(s.Progressbar, animationState === 'exiting' ? s.Exiting : '')}>
        <Progress
          testsCompleted={testsCompleted}
          testsTotal={testsTotal}
          sections={sections}
          percent={percent}
          current={current}
          order={order}
        />
      </div>
      <div className={s.StartButtonWrapper}>
        <button
          className={cl(s.StartButton, animationState === 'exiting' ? s.Exiting : '')}
          onClick={() => changePage()}
        >
          START
          <ButtonArrow />
        </button>
      </div>
    </div>
  );
}
